const validate = (values) => {
  const errors = {};
  const regexExp = /[\u21b5<p>/]/gi;

  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }
  if (!values.defaultTitle) {
    errors.defaultTitle = 'Esse campo não pode ficar vazio';
  }
  if (!values.defaultBodyInHTML) {
    errors.defaultBodyInHTML = 'Esse campo não pode ficar vazio';
  } else if (
    values.defaultBodyInHTML &&
    values.defaultBodyInHTML.replace(regexExp, '').length === 1
  ) {
    errors.defaultBodyInHTML = 'Esse campo não pode ficar vazio';
  }
  return errors;
};

export default validate;
